import { CLOUD_API_URL } from '../config/serverConfig';
import { getHeaders } from '../lib/useQobuz';
import { getQualityTier } from '../hooks/useAudioQuality';
import { QueueController } from '../transport/QueueController';
import { playLocalAlbumFromGrid } from './playLocalAlbum';
import { durationFromTrackRow } from './trackDuration';

export function isLocalLibraryAlbum(album) {
  if (!album) return false;
  if (album.__source === 'local_library' || album.isLocalLibrary === true || album.source === 'local_library') {
    return true;
  }
  const id = String(album.id || '');
  if (id.startsWith('qobuz:')) return false;
  return !!(album.album_key && !album.serviceAlbumId);
}

function qobuzCoverUrl(album) {
  const rawId = String(album?.serviceAlbumId || album?.id || '').trim().replace(/^qobuz:album:/, '');
  const constructed = (rawId.length >= 4
    && !/^[0-9a-f]{8}-[0-9a-f]{4}/i.test(rawId)
    && !/^\d+$/.test(rawId)
    && !rawId.includes(':'))
    ? `https://static.qobuz.com/images/covers/${rawId.slice(-2)}/${rawId.slice(-4, -2)}/${rawId}_600.jpg`
    : '';
  return album?.artworkUrl || album?.cover || album?.coverUrl || album?.image?.large || constructed || '';
}

function formatQobuzTrack(t, i, album, coverUrl, albumArtist) {
  const bd = t.maximum_bit_depth || t.maxBitDepth || album?.maximum_bit_depth || album?.maxBitDepth || null;
  const sr = t.maximum_sampling_rate || t.maxSampleRate || album?.maximum_sampling_rate || album?.maxSampleRate || null;
  const tier = getQualityTier(bd, sr);
  return {
    id: t.id || t.trackId || `track_${i}`,
    title: t.title || 'Unknown',
    artist: t.artistName || t.artist || albumArtist,
    album: album?.title || '',
    albumId: album?.id || album?.serviceAlbumId || null,
    albumTitle: album?.title || '',
    artworkUrl: t.artworkUrl || t.coverUrl || coverUrl,
    duration: durationFromTrackRow(t),
    source: t.source || album?.source || 'qobuz',
    qobuzTrackId: t.qobuzTrackId || t.serviceTrackId || t.id,
    bitDepth: bd,
    sampleRate: sr,
    format: tier && tier.tier !== 'cd' ? `${tier.label} FLAC` : 'FLAC',
  };
}

export async function playAlbumFromTile(album) {
  if (!album) return;

  if (isLocalLibraryAlbum(album)) {
    await playLocalAlbumFromGrid(album, { mode: 'play', source: 'tile-play' });
    return;
  }

  const rawId = String(album.serviceAlbumId || album.id || '').replace(/^qobuz:(album|track|artist):/, '');
  if (!rawId) return;

  const resp = await fetch(
    `${CLOUD_API_URL}/api/streaming/qobuz/album-tracks?album_id=${encodeURIComponent(rawId)}`,
    { headers: getHeaders() },
  );
  if (!resp.ok) return;

  const data = await resp.json();
  const tracks = data.tracks || [];
  if (!tracks.length) return;

  const coverUrl = qobuzCoverUrl(album);
  const albumArtist = album?.artist?.name || album?.artistName || album?.artist_name || '';
  const formatted = tracks.map((t, i) => formatQobuzTrack(t, i, album, coverUrl, albumArtist));
  QueueController.playFrom(formatted, 0);
}
